
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-funds/refund",
      function () {
        return require("private-next-pages/request-funds/refund.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-funds/refund"])
      });
    }
  